export default __webpack_public_path__ + "static/media/spinePelvicPain.5a97b82f.png";